import {makeAutoObservable} from "mobx";

export default class RequestChatStore {
    constructor() {
        this._messages = [];
        this._access = null;
        this._unreadCount = 0;
        this._lastNotification = null;

        this._lastReadMessageId = 0;
        this._lastReadAt = null;

        makeAutoObservable(this);
    }

    // -------- setters --------

    setMessages(messages) {
        this._messages = Array.isArray(messages) ? messages : [];
    }

    addMessage(message) {
        if (!message?.id) return false;

        const exists = this._messages.some(
            item => String(item.id) === String(message.id)
        );

        if (exists) return false;

        this._messages.push(message);
        return true;
    }

    setAccess(access) {
        this._access = access || null;
    }

    setUnreadCount(count) {
        this._unreadCount = Number(count || 0);
    }

    prependMessages(messages) {
        if (!Array.isArray(messages) || messages.length === 0) return;

        const existingIds = new Set(
            this._messages.map(item => String(item.id))
        );

        const uniqueMessages = messages.filter(
            item => item?.id && !existingIds.has(String(item.id))
        );

        if (uniqueMessages.length === 0) return;

        this._messages = [
            ...uniqueMessages,
            ...this._messages
        ];
    }

    setReadState({
                     unreadCount = 0,
                     lastReadMessageId = 0,
                     lastReadAt = null
                 } = {}) {
        this._unreadCount = Number(unreadCount || 0);
        this._lastReadMessageId = Number(lastReadMessageId || 0);
        this._lastReadAt = lastReadAt || null;
    }

    incrementUnread(message = null) {
        if (
            message?.id &&
            this._lastReadMessageId &&
            Number(message.id) <= Number(this._lastReadMessageId)
        ) {
            return;
        }

        this._unreadCount += 1;

        this._lastNotification = {
            id: Date.now(),
            message
        };
    }

    clearUnread() {
        this._unreadCount = 0;
    }

    clearLastNotification() {
        this._lastNotification = null;
    }

    clearStore() {
        this._messages = [];
        this._access = null;
        this._unreadCount = 0;
        this._lastNotification = null;

        this._lastReadMessageId = 0;
        this._lastReadAt = null;
    }

    // -------- getters --------

    get messages() {
        return this._messages;
    }

    get access() {
        return this._access;
    }

    get unreadCount() {
        return this._unreadCount;
    }

    get lastNotification() {
        return this._lastNotification;
    }

    get lastReadMessageId() {
        return this._lastReadMessageId;
    }

    get lastReadAt() {
        return this._lastReadAt;
    }
}